// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"numbers-2-1"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 19H8V16.976C8 16.6748 8.1357 16.3897 8.36941 16.1999L14.4983 11.2201C15.4484 10.4482 16 9.28925 16 8.06512V8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-numbers-2-1')
export default class Numbers21Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'numbers-2-1',
    }
  }
}
